export default __webpack_public_path__ + "static/media/narciso.eda563ef.png";